import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { AboutComponent } from './pages/about/about.component';
import { HomeComponent } from './pages/home/home.component';
import { RouterModule } from '@angular/router';
import {AppRoutingModule} from "./app-routing.module";
import { CommercialRefrigerationComponent } from './pages/commercial-refrigeration/commercial-refrigeration.component';
import { ContactComponent } from './pages/contact/contact.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { IceMachinesComponent } from './pages/ice-machines/ice-machines.component';
import { SoftServeMachinesComponent } from './pages/soft-serve-machines/soft-serve-machines.component';
import { NavComponent } from './components/nav/nav.component';

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    HomeComponent,
    CommercialRefrigerationComponent,
    ContactComponent,
    CustomersComponent,
    IceMachinesComponent,
    SoftServeMachinesComponent,
    NavComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts